module.exports = __webpack_public_path__ + "static/media/stockhausen_blicke_37.76ccc23a.jpg";